import styled from '@emotion/styled';
import { ChevronIcon, useOnClickOutside } from 'dw-au-react-components';
import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import MenuLink from './MenuLink';

const StyledMobileMenu = styled.div`
	background: #ffffff;
	border: 1px solid #e3e3e3;
	border-radius: 2px;
	padding: 10px;
	position: relative;
`;

function MobileMenu({ faqData, privacyData }) {
	let { question } = useParams();
	const ref = useRef();
	const [dropDownClass, setDropDownClass] = useState('');
	const [arrowDirection, setArrowDirection] = useState('down');

	// Close mobile dropdown on outside click
	useOnClickOutside(ref, () => setDropDownClass(''));

	const filteredRouteData = [...faqData, ...privacyData];
	let listItems = filteredRouteData
		.filter((data) => data.slug === question)
		.map((routeData) => routeData.title);

	useEffect(() => {
		setDropDownClass('');
	}, [question]);

	const handleClick = () => {
		if (dropDownClass) {
			setDropDownClass('');
			setArrowDirection('down');
		} else {
			setDropDownClass('d-block');
			setArrowDirection('up');
		}
	};

	return (
		<StyledMobileMenu ref={ref}>
			<div
				className='selected-menu d-flex align-items-center justify-content-between text-dark-medium'
				onClick={handleClick}
			>
				{listItems}
				<ChevronIcon direction={arrowDirection} fill='#9E9E9E' />
			</div>

			<div className={`dropdown-menu w-100 ${dropDownClass}`}>
				{faqData?.map(({ title, slug }, index) => {
					return (
						<MenuLink
							key={index}
							name={title}
							link={`/customer-services/faq/${slug}`}
						/>
					);
				})}
				{privacyData
					?.sort((a, b) => {
						return a.order < b.order ? -1 : a.order > b.order ? 1 : 0;
					})
					.map(({ title, slug }, index) => {
						return (
							<MenuLink
								key={index}
								name={title}
								link={`/customer-services/legal/${slug}`}
							/>
						);
					})}
			</div>
		</StyledMobileMenu>
	);
}

export default MobileMenu;
